import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/icons/close.svg'


const _hoisted_1 = { class: "flex flex-col min-h-screen" }
const _hoisted_2 = { class: "flex flex-col flex-grow bg-background" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "bg-white" }
const _hoisted_5 = { class: "container" }
const _hoisted_6 = { class: "flex flex-row justify-between text-2xl py-4" }
const _hoisted_7 = { class: "relative" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Global payroll")
], -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "relative" }
const _hoisted_11 = { class: "flex flex-row items-center" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "Period:", -1)
const _hoisted_13 = { class: "font-semibold mx-4" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_15 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6 text-black",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M19 9l-7 7-7-7"
  })
], -1)
const _hoisted_16 = {
  key: 0,
  ref: "periodDropdown",
  class: "absolute inset-x-0 top-0 mt-12 w-auto bg-white rounded shadow z-50 text-base text-center"
}
const _hoisted_17 = ["onClick"]
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_19 = {
  key: 0,
  class: "bg-gray-300 h-px w-full -mb-4 mt-4"
}
const _hoisted_20 = {
  key: 1,
  class: "shadow-inner"
}
const _hoisted_21 = { class: "container py-8" }
const _hoisted_22 = { class: "flex flex-col" }
const _hoisted_23 = { class: "flex flex-col 2xl:flex-row items-stretch" }
const _hoisted_24 = { class: "flex flex-row justify-between flex-grow bg-black rounded-2xl p-8" }
const _hoisted_25 = { class: "flex flex-col" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "font-sm text-gray-500" }, " Clients ", -1)
const _hoisted_27 = {
  key: 0,
  class: "text-3xl text-white font-bold"
}
const _hoisted_28 = { class: "flex flex-col" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", { class: "font-sm text-gray-500" }, " Total ", -1)
const _hoisted_30 = {
  key: 0,
  class: "text-3xl text-white font-bold"
}
const _hoisted_31 = { class: "flex flex-col card-main mt-8" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Timeline", -1)
const _hoisted_33 = {
  key: 0,
  class: "mt-4 text-gray-500"
}
const _hoisted_34 = { class: "bg-white rounded-2xl pt-8 pb-2 px-2 shadow mt-8" }
const _hoisted_35 = { class: "table-auto w-full" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "text-gray-500" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "font-normal" }, "Client"),
    /*#__PURE__*/_createElementVNode("th", { class: "font-normal" }, "Employees"),
    /*#__PURE__*/_createElementVNode("th", { class: "font-normal" }, "Payment date"),
    /*#__PURE__*/_createElementVNode("th", { class: "font-normal" }, "Total"),
    /*#__PURE__*/_createElementVNode("th", { class: "font-normal" }, "Pending invoices")
  ])
], -1)
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { class: "ml-8" }
const _hoisted_39 = { class: "px-4 w-2/12" }
const _hoisted_40 = { class: "flex flex-row justify-center" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-5 text-gray-500",
  viewBox: "0 0 20 20",
  fill: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3zM6 8a2 2 0 11-4 0 2 2 0 014 0zM16 18v-3a5.972 5.972 0 00-.75-2.906A3.005 3.005 0 0119 15v3h-3zM4.75 12.094A5.973 5.973 0 004 15v3H1v-3a3 3 0 013.75-2.906z" })
], -1)
const _hoisted_42 = { class: "ml-4 font-semibold" }
const _hoisted_43 = { class: "px-4 w-2/12" }
const _hoisted_44 = { class: "font-semibold text-gray-500" }
const _hoisted_45 = { class: "px-4 w-2/12" }
const _hoisted_46 = { class: "bg-black text-white rounded-full px-4 py-1" }
const _hoisted_47 = { class: "px-4 w-2/12" }
const _hoisted_48 = ["onClick"]
const _hoisted_49 = {
  key: 0,
  class: "flex justify-center items-center fixed inset-y-0 right-0 overflow-x-hidden overflow-y-hidden z-50 w-full"
}
const _hoisted_50 = { class: "flex relative w-1/2 h-auto" }
const _hoisted_51 = { class: "flex flex-col bg-white w-full h-auto rounded-2xl shadow p-8" }
const _hoisted_52 = { class: "flex flex-row justify-between" }
const _hoisted_53 = { class: "flex flex-col text-1xl font-semibold" }
const _hoisted_54 = { class: "flex flex-col justify-end" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_56 = [
  _hoisted_55
]
const _hoisted_57 = { class: "flex flex-row justify-between items-start pt-8" }
const _hoisted_58 = { class: "flex flex-col pl-8 w-full" }
const _hoisted_59 = { class: "flex flex-col pt-4" }
const _hoisted_60 = { class: "table-auto w-full" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "text-gray-500" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "font-normal" }, "Date"),
    /*#__PURE__*/_createElementVNode("th", { class: "font-normal" }, "Total")
  ])
], -1)
const _hoisted_62 = ["onClick"]
const _hoisted_63 = { class: "px-4 py-4" }
const _hoisted_64 = { class: "font-semibold text-gray-500" }
const _hoisted_65 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_66 = { class: "font-semibold text-gray-500" }
const _hoisted_67 = { class: "px-4" }
const _hoisted_68 = { class: "flex flex-row justify-center" }
const _hoisted_69 = { class: "ml-4 font-semibold" }
const _hoisted_70 = {
  key: 1,
  class: "bg-black opacity-50 fixed inset-y-0 right-0 z-40 w-full"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_ErrorState = _resolveComponent("ErrorState")!
  const _component_DateFormatter = _resolveComponent("DateFormatter")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_CompanyCard = _resolveComponent("CompanyCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.error)
        ? (_openBlock(), _createBlock(_component_ErrorState, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("button", {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showClientDropdown = !_ctx.showClientDropdown))
                    }, _hoisted_9)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("button", {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showPeriodDropdown = true))
                    }, [
                      _createElementVNode("div", _hoisted_11, [
                        _hoisted_12,
                        _createElementVNode("span", _hoisted_13, [
                          _createVNode(_component_DateFormatter, {
                            date: _ctx.selectedPeriod.start_date
                          }, null, 8, ["date"]),
                          _hoisted_14,
                          _createVNode(_component_DateFormatter, {
                            date: _ctx.selectedPeriod.end_date
                          }, null, 8, ["date"])
                        ]),
                        _hoisted_15
                      ])
                    ]),
                    (_ctx.showPeriodDropdown)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.periods, (period, i) => {
                            return (_openBlock(), _createElementBlock("button", {
                              onClick: ($event: any) => (_ctx.changePeriod(period)),
                              key: i,
                              class: "p-4 w-full rounded hover:bg-background-secondary"
                            }, [
                              _createVNode(_component_DateFormatter, {
                                date: period.start_date
                              }, null, 8, ["date"]),
                              _hoisted_18,
                              _createVNode(_component_DateFormatter, {
                                date: period.end_date
                              }, null, 8, ["date"]),
                              (i < _ctx.periods.length - 1)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_19))
                                : _createCommentVNode("", true)
                            ], 8, _hoisted_17))
                          }), 128))
                        ], 512))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]),
            (_ctx.loading)
              ? (_openBlock(), _createBlock(_component_Loader, {
                  key: 0,
                  class: "mt-4"
                }))
              : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("div", _hoisted_25, [
                            _hoisted_26,
                            (_ctx.meta.pagination)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(_ctx.meta.pagination.total_count), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_28, [
                            _hoisted_29,
                            (_ctx.meta.payrolls_total)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_30, " $" + _toDisplayString((_ctx.meta.payrolls_total / 100).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })), 1))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_31, [
                        _hoisted_32,
                        (_ctx.timeline.length === 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_33, " There is no additional event or activity requested in this payroll period. "))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("table", _hoisted_35, [
                          _hoisted_36,
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clients, (client, i) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: i,
                                class: "align-middle text-center border-t border-gray-300"
                              }, [
                                _createElementVNode("td", {
                                  onClick: ($event: any) => (_ctx.$router.push(`/payroll/${client.company.id}`)),
                                  class: "px-4 py-4 cursor-pointer"
                                }, [
                                  _createElementVNode("div", _hoisted_38, [
                                    _createVNode(_component_CompanyCard, {
                                      companyName: client.company.visible_name
                                    }, null, 8, ["companyName"])
                                  ])
                                ], 8, _hoisted_37),
                                _createElementVNode("td", _hoisted_39, [
                                  _createElementVNode("div", _hoisted_40, [
                                    _hoisted_41,
                                    _createElementVNode("span", _hoisted_42, _toDisplayString(client.total_users), 1)
                                  ])
                                ]),
                                _createElementVNode("td", _hoisted_43, [
                                  _createElementVNode("span", _hoisted_44, [
                                    _createVNode(_component_DateFormatter, {
                                      date: client.end_date
                                    }, null, 8, ["date"])
                                  ])
                                ]),
                                _createElementVNode("td", _hoisted_45, [
                                  _createElementVNode("div", _hoisted_46, [
                                    _createElementVNode("span", null, " $" + _toDisplayString((client.payrolls_total / 100).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })) + " USD ", 1)
                                  ])
                                ]),
                                _createElementVNode("td", _hoisted_47, [
                                  _createElementVNode("div", {
                                    onClick: ($event: any) => (_ctx.showPendingInvoices(client.id)),
                                    class: "border-2 rounded-full px-4 py-1 cursor-pointer"
                                  }, _toDisplayString(client.pending_invoices?.count), 9, _hoisted_48)
                                ]),
                                (_ctx.pendingInvoicesToShow === client.id)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                      _createElementVNode("div", _hoisted_50, [
                                        _createElementVNode("div", _hoisted_51, [
                                          _createElementVNode("div", _hoisted_52, [
                                            _createElementVNode("div", _hoisted_53, _toDisplayString(client.company.name) + "'s pending payment invoices ", 1),
                                            _createElementVNode("div", _hoisted_54, [
                                              _createElementVNode("button", {
                                                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.pendingInvoicesToShow = ''))
                                              }, _hoisted_56)
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_57, [
                                            _createElementVNode("div", _hoisted_58, [
                                              _createElementVNode("div", _hoisted_59, [
                                                _createElementVNode("table", _hoisted_60, [
                                                  _hoisted_61,
                                                  _createElementVNode("tbody", null, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(client
                                          .pending_invoices?.payroll_periods, (pendingInvoice, i) => {
                                                      return (_openBlock(), _createElementBlock("tr", {
                                                        key: 'pending_invoice' + i,
                                                        onClick: ($event: any) => (
                                          _ctx.$router.push(
                                            `/payroll/${client.company.id}/${pendingInvoice.id}`
                                          )
                                        ),
                                                        class: "align-middle text-center border-t border-gray-300 cursor-pointer"
                                                      }, [
                                                        _createElementVNode("td", _hoisted_63, [
                                                          _createElementVNode("span", _hoisted_64, [
                                                            _createVNode(_component_DateFormatter, {
                                                              date: pendingInvoice.start_date
                                                            }, null, 8, ["date"])
                                                          ]),
                                                          _hoisted_65,
                                                          _createElementVNode("span", _hoisted_66, [
                                                            _createVNode(_component_DateFormatter, {
                                                              date: pendingInvoice.end_date
                                                            }, null, 8, ["date"])
                                                          ])
                                                        ]),
                                                        _createElementVNode("td", _hoisted_67, [
                                                          _createElementVNode("div", _hoisted_68, [
                                                            _createElementVNode("span", _hoisted_69, " $" + _toDisplayString((
                                                  pendingInvoice.payrolls_total / 100
                                                ).toLocaleString(undefined, {
                                                  minimumFractionDigits: 2,
                                                  maximumFractionDigits: 2,
                                                })) + " USD ", 1)
                                                          ])
                                                        ])
                                                      ], 8, _hoisted_62))
                                                    }), 128))
                                                  ])
                                                ])
                                              ])
                                            ])
                                          ])
                                        ])
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.pendingInvoicesToShow === client.id)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_70))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128))
                          ])
                        ])
                      ])
                    ])
                  ])
                ]))
          ]))
    ])
  ]))
}